import script from "./System.vue?vue&type=script&setup=true&lang=js"
export * from "./System.vue?vue&type=script&setup=true&lang=js"

import "./System.vue?vue&type=style&index=0&id=3fe523da&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fe523da"]])

export default __exports__